import { CountriesResponse } from '@/types/service-response'

export class AddressCountry {
  public constructor (
    readonly id: number,
    readonly name: string
  ) {}

  static createFromResponse (responseData: CountriesResponse[]): Array<AddressCountry> {
    return responseData.map((land: CountriesResponse ) => {
      return new AddressCountry(
        land.ID,
        land.Name,
      )
    })
  }
}
